/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type ConnectAppControlsSettingsType from '@jira/spa-apps__project-settings-connect-app-controls/src/ProjectSettingsConnectAppControls.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyConnectAppControlsSettings: LazyComponent<React.ComponentType<Record<any, any>>> =
	lazyForPaint<typeof ConnectAppControlsSettingsType>(() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-project-settings-connect-app-controls", jiraSpaEntry: "async-project-settings-connect-app-controls" */ '@jira/spa-apps__project-settings-connect-app-controls/src/ProjectSettingsConnectAppControls.tsx'
			),
		),
	);

const AsyncConnectAppControlsSettings = (): React.JSX.Element => (
	<LazyPage
		Page={LazyConnectAppControlsSettings}
		pageId="project-settings-connect-app-controls"
		shouldShowSpinner={false}
	/>
);

export default AsyncConnectAppControlsSettings;
